import { render, staticRenderFns } from "./chatDialog.vue?vue&type=template&id=1895b602&scoped=true&"
import script from "./chatDialog.vue?vue&type=script&lang=js&"
export * from "./chatDialog.vue?vue&type=script&lang=js&"
import style0 from "./chatDialog.vue?vue&type=style&index=0&id=1895b602&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1895b602",
  null
  
)

export default component.exports